import React from 'react';
import TrendChartsPage from './TrendChartsPage';
import { connect } from 'react-redux';
import { dashboardActions } from '../../../../actions/dashboard.action';
import Loading from '../../../Helpers/Loading';
import Backend from '../../../Layouts/Backend';
import qs from 'qs';
import { cloneDeep, maxBy, minBy } from 'lodash';
import formatData from './formatData';
import helper from '../../../../utils/helper';
import LayoutMobile from '../../../Layouts/LayoutMobile';
import { getMetaData, getMaxDataPoint } from './helpers';
import { getTrend } from '../../../../api/dashboard';

const TrendCharts = (props) => {
  const [state, setState] = React.useState({
    loading: false,
    errors: '',
    data: [],
    metaData: null,
    maxDataPoint: undefined,
    units: '',
    chartMin: null,
    chartMax: null,
  });
  const [errors, setErrors] = React.useState('');
  const [loading, setLoading] = React.useState(true);
  function getData() {
    const { sensorIds, fromDate, toDate } = qs.parse(props.location.search, {
      ignoreQueryPrefix: true,
    });
    getTrend(sensorIds, fromDate, toDate)
      .then((resp) => {
        const [sensorNames, data] = formatData(cloneDeep(resp));
        const metaData = getMetaData(cloneDeep(resp));
        const maxDataPoint = getMaxDataPoint(cloneDeep(resp));
        const units = data.length && resp.length ? resp[0].units : '';
        const chartMax = maxBy(resp, (o) => o.chartMax).chartMax;
        const chartMin = minBy(resp, (o) => o.chartMin).chartMin;
        setState({
          data,
          metaData,
          maxDataPoint,
          units,
          chartMin,
          chartMax,
        });
      })
      .catch((err) => setErrors(err))
      .finally(() => setLoading(false));
  }
  React.useEffect(() => {
    getData();
  }, []);
  const Container = helper.isMobile() ? LayoutMobile : Backend;
  if (loading) {
    return (
      <Container>
        <Loading />
      </Container>
    );
  }
  return (
    <Container>
      <TrendChartsPage
        {...state}
        // data={_example}
        // units={units}
        // sensorNames={sensorNames}
        // metaData={metaData}
        // maxDataPoint={maxDataPoint}
        // chartMin={chartMin}
        // chartMax={chartMax}
      />
    </Container>
  );
};

export default TrendCharts;
